import { getAction } from "@/api/manage";

const warehouse = {
  namespaced: true,
  state: {
    warehouseExitList: [], // 存储仓库出库列表数据
  },
  mutations: {
    // 设置仓库出库列表数据
    SET_WAREHOUSE_EXIT_LIST(state, data) {
      state.warehouseExitList = data;
    },
  },
  actions: {
    // 获取仓库出库列表数据
    async queryWarehouseExitList(
      { commit, state },
      { warehouseId = [10, 11] } = {}
    ) {
      try {
        // 清空现有数据，准备接收新数据
        let allResults = [];
        // 循环处理每个warehouseId
        for (const id of warehouseId) {
          const params = {
            warehouseId: id,
          };
          const res = await getAction("/wmsRS/warehouseExit/queryList", params);
          if (res && res.success) {
            // 将每个请求的结果追加到总结果数组
            allResults = allResults.concat(res.result || []);
          }
        }
        // 更新state
        commit("SET_WAREHOUSE_EXIT_LIST", allResults);
        return { success: true, result: allResults };
      } catch (error) {
        console.error("获取仓库出库列表失败:", error);
        return error;
      }
    },
  },
  getters: {
    // 获取仓库出库列表
    getWarehouseExitList: (state) => {
      return state.warehouseExitList;
    },
  },
};

export default warehouse;
